// Vendors
import React, { useState } from 'react';
import { Typography } from '@mui/material';

// Components
import Pagination from '@/components/atoms/Pagination/Pagination';
import ReusablePopup from '@/components/organism/PopUp/ReusablePopup/ReusablePopup';
import { POPUP_TYPES } from '@/utils/constants';
import { useNavigate } from 'react-router-dom';

interface ContractListData {
  title: string;
  subtitle: string;
  headers: string[];
  rows: string[][];
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  data: ContractListData;
  clientId?: string;
}

const CustomerContractListPopup: React.FC<Props> = ({ isOpen, onClose, data,clientId }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 7;
  const navigate = useNavigate();

  const totalItems = data.rows.length;
  const currentRows = data.rows.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage);
  const equipmentvalue = data.headers.findIndex((h) => h.toLowerCase() === 'equip value');
  const contractIdIndex = data.headers.findIndex((h) => h.toLowerCase() === 'contract #');

  const formatAmount = (value: string): string => {
    if (value) {
      const clean = value.replace(/,/g, '').trim();

      const number = parseFloat(clean);
      if (isNaN(number)) return value;
      return number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else return '';
  };
  const handleContractClick = (contractId: string) => {
    try {
      // const recent: RecentSearch = {
      //   ...contract,
      //   userId: username,
      //   createdAt: new Date().toISOString(),
      // };
      // void ContractService.postRecentSearch(recent);
      void navigate(`/contracts/${contractId}${clientId ? `/client/${clientId}`: ''}`);
      onClose();
    } catch (error) {
      console.error('Error fetching contract details:', error);
    }
  };
  return (
    <ReusablePopup
      isOpen={isOpen}
      onClose={onClose}
      typeClassName="contract-list-popup"
      header={data.title}
      type={POPUP_TYPES.CONTRACT_LIST}
      isPaginationShown={totalItems > rowsPerPage}
    >
      <Typography className="sub-title">{totalItems} related contracts found</Typography>

      <table className="popup-table">
        <thead>
          <tr>
            {data.headers.map((h, i) => (
              <th key={i}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentRows.map((row, idx) => (
            <tr key={idx}>
              {row.map((cell, cellIdx) => {
                let formattedCell = cell;

                if (cellIdx === equipmentvalue) {
                  formattedCell = formatAmount(cell);
                }
                const isContractIdCell = cellIdx === contractIdIndex;

                return <td key={cellIdx}
                  onClick={() =>
                    isContractIdCell &&
                    handleContractClick(formattedCell)}>{formattedCell}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>

      {totalItems > rowsPerPage && (
        <div className="pagination_wrap">
          <div />
          <Pagination
            totalItems={totalItems}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </ReusablePopup>
  );
};

export default CustomerContractListPopup;
